var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecognitionReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 68,
    viewBox: "0 0 59 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_478209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.21 31.08L58.09 30.77L58.05 30H57.62L47.63 15H36.1V17H46.56L55.24 30H39.1V37H19.1V30H2.96L11.64 17H22.1V15H10.57L0.53 30.03L0.1 30.05V30.86L0 31.11L0.1 31.25V50.61C0.1 52.48 1.62 54 3.49 54H54.72C56.59 54 58.1 52.48 58.1 50.62V31.24L58.21 31.08ZM56.1 50.62C56.1 51.38 55.48 52 54.72 52H3.49C2.73 52 2.11 51.38 2.11 50.62V32H17.11V39H41.11V32H56.11V50.62H56.1Z",
    fill: "#178087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8099 22.29C21.4199 21.9 20.7899 21.9 20.3999 22.29C20.0099 22.68 20.0099 23.31 20.3999 23.7L28.3999 31.7L29.1099 32.41L29.8199 31.7L37.8199 23.7C38.2099 23.31 38.2099 22.68 37.8199 22.29C37.4299 21.9 36.7999 21.9 36.4099 22.29L30.1199 28.58V1C30.1199 0.45 29.6699 0 29.1199 0C28.5699 0 28.1199 0.45 28.1199 1V28.59L21.8099 22.29Z",
    fill: "#178087"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_478209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.21,
    height: 67.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecognitionReceived);
export default __webpack_public_path__ + "static/media/recognition-received.f78ff410529006afa08b3e277a2fedc9.svg";
export { ForwardRef as ReactComponent };